import useAuth from '@src/core/auth/components/auth0-wrapper';
import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';
import { useCallback } from 'react';
import { ErrorPageTemplate } from 'swo-ciam-common-react';
import image from '../../../../../../public/images/no_email.png';
import { RoutePathsEnum } from '../../../route-paths.enum';

const DefaultAuthErrorComponent = () => {
  const { logout } = useAuth();
  const buttonClickHandler = useCallback(
    () => logout({ returnTo: window.location.origin }),
    [logout]
  );

  return (
    <ErrorPageTemplate
      items={[
        { key: LocaleTranslationKeysEnum.AuthUnknownErrorTitle },
        {
          key: LocaleTranslationKeysEnum.AuthUnknownErrorSubTitle,
        },
      ]}
      link={{ external: false, url: RoutePathsEnum.Home }}
      image={{ src: image, alt: LocaleTranslationKeysEnum.SwoErrorPages500ImgAlt }}
      button={{
        label: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        placeholder: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoBack,
        onClick: buttonClickHandler,
      }}
      footerText={{
        key: LocaleTranslationKeysEnum.SwoErrorPagesSharedFooterText,
      }}
    />
  );
};

export default DefaultAuthErrorComponent;
